import React from 'react'
import {Redirect, Route, Switch, withRouter} from 'react-router-dom'
import ChangePlan from './ChangePlan'
import Payment from './Payment'

const PlanRoutes = ({match: {path,url}}) => (
  <Switch>
    <Route exact path={`${path}/payment`} component={Payment} />
    <Route exact path={`${path}/change-plan`} component={ChangePlan} />
    <Route path={`${path}/:parentPath/:childPath+`} render={({match}) => <Redirect to={`${path}/${match.params.parentPath}`} />} />
    <Route path={`${path}`} component={ChangePlan} />
  </Switch>
)

export default withRouter(PlanRoutes)
